import { useFaireSourceEligibility } from "@faire/deprecated-retailer-visitor-shared/features/Cart/FaireSource/useFaireSourceEligibility";
import { getCartToken } from "@faire/deprecated-retailer-visitor-shared/serialized-data/getCartToken";
import { QueryParameters as FaireSourceSummaryQueryParameters } from "@faire/web-api--source/endpoints/www/api/v2/carts/cartToken/fbf-benefits-cart/get";
import {
  useInvalidateQuery as useFaireSourceSummaryInvalidateQuery,
  useQuery as _useFaireSourceSummary,
} from "@faire/web-api--source/endpoints/www/api/v2/carts/cartToken/fbf-benefits-cart/get-hooks";
import { IBrandCartV2 } from "@faire/web-api--source/faire/carts/IBrandCartV2";
import { IGetFbfBenefitsCartDataResponse } from "@faire/web-api--source/faire/carts/IGetFbfBenefitsCartDataResponse";
import { useCallback, useMemo } from "react";

export const useFaireSourceSummary = (
  selectedBrandTokens?: string[],
  options?: { disabled?: boolean }
) => {
  const cartToken = getCartToken();
  const isFaireSourceEligible = useFaireSourceEligibility();
  const { data, isPending, error, isFetching, isLoading, refetch } =
    _useFaireSourceSummary(
      cartToken,
      FaireSourceSummaryQueryParameters.build({
        brand_tokens: selectedBrandTokens,
      }),
      {
        enabled: !!cartToken && isFaireSourceEligible && !options?.disabled,
      }
    );

  const state = useMemo(() => {
    const amountBelowMinimum =
      data?.minimum_info?.amount_below_minimum?.amount_cents;
    if (amountBelowMinimum === undefined) {
      return IBrandCartV2.State.STATE_UNKNOWN;
    }
    if (amountBelowMinimum <= 0) {
      return IBrandCartV2.State.READY_FOR_CHECKOUT;
    }

    return IBrandCartV2.State.BELOW_MINIMUM;
  }, [data?.minimum_info?.amount_below_minimum?.amount_cents]);

  return {
    data: data
      ? {
          ...IGetFbfBenefitsCartDataResponse.build(data),
          state,
        }
      : undefined,
    isPending: isPending || isLoading || isFetching,
    error,
    refetch,
  };
};

export const useInvalidateFaireSourceSummary = () => {
  const invalidateCartQuery = useFaireSourceSummaryInvalidateQuery();

  const invalidateCartRequest = useCallback(async () => {
    const args = [
      getCartToken(),
      FaireSourceSummaryQueryParameters.build({}),
      undefined,
      { refetchType: "all" },
    ] as const;
    await Promise.all([invalidateCartQuery(...args)]);
  }, [invalidateCartQuery]);

  return invalidateCartRequest;
};
